import { Box, Typography } from "@mui/material";
import DriverTable from "Components/DriverManagement/DriverTable";
import { useRTL } from "hooks/isRTL";

const DriverManagement = () => {
  const { t } = useRTL();

  return (
    <Box
      sx={{
        padding: "3.2rem 4.5rem",
        height: "100%",
        overflowY: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h1">{t("driverManagement")}</Typography>
      </Box>
      <DriverTable />
    </Box>
  );
};

export default DriverManagement;
